import { Button } from "@/components/ui/button";
import { CheckCircle, Loader2 } from 'lucide-react';
import { useNotify, useRecordContext, useUpdate } from 'ra-core';
import { useState } from 'react';
import type { BoM } from '../types';

export const ApproveBoMButton = () => {
    const record = useRecordContext<BoM>();
    const notify = useNotify();
    const [update, { isPending }] = useUpdate();
    const [loading, setLoading] = useState(false);

    if (!record || record.status !== 'draft') return null;

    const handleApprove = () => {
        setLoading(true);
        update(
            'boms',
            { id: record.id, data: { status: 'approved' }, previousData: record },
            {
                onSuccess: () => {
                    notify('BoM Approved successfully', { type: 'success' });
                    setLoading(false);
                },
                onError: (error: any) => {
                    notify(`Error approving BoM: ${error.message}`, { type: 'error' });
                    setLoading(false);
                }
            }
        );
    };

    return (
        <Button 
            onClick={handleApprove} 
            disabled={loading || isPending}
            variant="default"
            className="bg-emerald-600 hover:bg-emerald-700 text-white gap-2 h-9 px-4 rounded-md shadow-sm transition-all"
        >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle className="w-4 h-4" />}
            Approve BoM
        </Button>
    );
};
